/**
 * Mirrors the browser's `type="url"` constraint, which the signup form
 * disables with `noValidate` so it can show its own field errors: the value
 * must parse as an absolute http(s) URL with a host.
 */
export const isValidWebsiteUrl = (value: string) => {
  try {
    const url = new URL(value.trim());
    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      url.hostname.length > 0
    );
  } catch {
    return false;
  }
};
